var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-form",
          {
            attrs: {
              model: _vm.formData,
              rules: _vm.rules,
              "label-position": _vm.labelPosition,
              "label-width": "140px",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "库存节点名称", prop: "nodeName" } },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.nodeName,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "nodeName", $$v)
                            },
                            expression: "formData.nodeName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "库存节点编号", prop: "nodeNo" } },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.nodeNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "nodeNo", $$v)
                            },
                            expression: "formData.nodeNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "库存节点组", prop: "nodeGroup" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "handle-input",
                            model: {
                              value: _vm.formData.nodeGroup,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "nodeGroup", $$v)
                              },
                              expression: "formData.nodeGroup",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "1",
                              attrs: { label: "外库", value: "外库" },
                            }),
                            _c("el-option", {
                              key: "2",
                              attrs: { label: "成品库", value: "成品库" },
                            }),
                            _c("el-option", {
                              key: "3",
                              attrs: { label: "工厂库", value: "工厂库" },
                            }),
                            _c("el-option", {
                              key: "4",
                              attrs: { label: "供应商", value: "供应商" },
                            }),
                            _c("el-option", {
                              key: "6",
                              attrs: { label: "客户", value: "客户" },
                            }),
                            _c("el-option", {
                              key: "7",
                              attrs: { label: "制造", value: "制造" },
                            }),
                            _c("el-option", {
                              key: "8",
                              attrs: { label: "维修", value: "维修" },
                            }),
                            _c("el-option", {
                              key: "9",
                              attrs: { label: "售后", value: "售后" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否有效", prop: "isEffective" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "handle-input",
                            model: {
                              value: _vm.formData.isEffective,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "isEffective", $$v)
                              },
                              expression: "formData.isEffective",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "1",
                              attrs: { label: "是", value: "是" },
                            }),
                            _c("el-option", {
                              key: "0",
                              attrs: { label: "否", value: "否" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "运输地址" } },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "主要联系人" } },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "主要联系人电话" } },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "主要联系人邮箱" } },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "次要联系人" } },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "次要联系人电话" } },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "次要联系人邮箱" } },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "name", $$v)
                            },
                            expression: "formData.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "btn-row" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.saveNodeInfo } },
              [_vm._v("保存")]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.cancel } },
              [_vm._v("取消")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }